import { createContext } from "react";
var defaultPrefix = "id";

function generateRandomString(prefix) {
  if (prefix === void 0) {
    prefix = defaultPrefix;
  }

  return (prefix ? prefix + "-" : "") + Math.random().toString(32).substr(2, 6);
}

var unstable_IdContext = /* @__PURE__ */createContext(generateRandomString);
export { unstable_IdContext };